import { IProject } from '@photosi/expo-photosi-sdk/build/Project';
import { IImageEditor } from '@photosi/expo-photosi-sdk/build/ImageEditor';
import { IPhotosiSdk } from '@photosi/expo-photosi-sdk/build/PhotosiSdk';

export const sdkProjects: Map<string, IProject> = new Map<string, IProject>();
export const sdkEditors: Map<string, IImageEditor> = new Map<string, IImageEditor>();


/* // To be used in the all afterAttach function because the sdkProject could be undefined. As of now this function doesn't exist on SDK side, we replaced it using awaitSdkProject in basemodel

export const loadProjectInstance = async(projectId: string, sdk: IPhotosiSdk) => {
  const projectInstance = await sdk.getProjectInstance(projectId); // getProjectInstance new WIP sdk function
  sdkProjects.set(projectId, projectInstance);
};
 */